/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadTasksByPriority } from 'store/actions/dashboard/dashboardActions';
import { bind } from 'app/utils/decorators/decoratorUtils';
import Widget from 'app/components/atoms/Widget/Widget';
import LinkList from 'app/containers/LandingPage/Widgets/LinkList';
import WidgetFooter from 'app/containers/LandingPage/Widgets/WidgetFooter';
import { getPriorityLabel } from 'app/config/aboxConfig';
import { get } from 'app/utils/lo/lo';
import { canViewWidget, PriorityTypography, widgetTypes } from '../dashboardUtils';

/**
 * Widget for displaying tasks assigned by priority to the active user
 */
class TasksByPriorityWidget extends PureComponent {
    static propTypes = {
        loadTasksByPriority: PropTypes.func,
        isLoading: PropTypes.bool,
        records: PropTypes.array,
        user: PropTypes.object,
    };

    constructor(props) {
        super(props);
        const canView = canViewWidget(props?.item, props?.type);
        canView && props.loadTasksByPriority(props.user, { linkOnly: true });
    }

    @bind
    renderFooterContent() {
        const orderBy = { field: 'primary.priority', direction: 'asc nulls last' };
        return <WidgetFooter orderBy={orderBy} />;
    }
    @bind
    renderAdditionalInfo(props) {
        const primary = get(props, 'primary');
        const { priority } = primary;
        const label = getPriorityLabel(priority);
        return <PriorityTypography value={priority}>{label}</PriorityTypography>;
    }
    @bind
    handleMenuItemClick(menu) {
        const { user, loadTasksByPriority, menuItemClick } = this.props;
        if (menu === 'Refresh') {
            loadTasksByPriority(user);
        } else {
            menuItemClick && menuItemClick(menu);
        }
    }

    render() {
        const { isLoading, records, item, permissions } = this.props;
        return (
            <Widget
                title={item?.widgetName || 'Highest Priority Tasks'}
                subHeader='Priority'
                content={
                    !isLoading && !records?.length ? (
                        'No Results'
                    ) : (
                        <LinkList list={records} type='task' renderAdditionalInfo={this.renderAdditionalInfo} />
                    )
                }
                loading={isLoading}
                footerContent={this.renderFooterContent}
                menuItemClick={this.handleMenuItemClick}
                permissions={permissions}
                item={item}
                type={widgetTypes.user}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.profile,
        isLoading: state.dashboard.tasksByPriority.isLoading,
        records: state.dashboard.tasksByPriority.records,
    };
};

export default connect(mapStateToProps, { loadTasksByPriority })(TasksByPriorityWidget);
